export default __webpack_public_path__ + "static/media/distance.837fe118.svg";